import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row-reverse',
    },
    leftContainer: {
        flexDirection: 'row',
    },
    textContainer: {
        backgroundColor: COLOR.JUMP_MARKER_RED,
        justifyContent: 'center',
    },
    rightTextContainer: {
        borderBottomLeftRadius: 2,
        borderTopLeftRadius: 2,
        paddingLeft: 6,
    },
    leftTextContainer: {
        borderBottomRightRadius: 2,
        borderTopRightRadius: 2,
        paddingRight: 6,
    },
    text: {
        fontFamily: Fonts.main.bold,
        fontWeight: '700',
        textAlign: 'right',
        marginBottom: 2,
    },
});

export default styles;
